<div id="main" class="internal">
  <div id="calendar" class="section calendar">
    <div class="content-body">
      <div class="content">
        <div class="content-header clickable" (click)="Back()">
          <button class="costa-button back">
            <img src="../../../assets/images/back.svg" alt="Back button" />
          </button>
          <div class="step">
            {{ "stepper.step" | translate }} <b>2</b>
            {{ "stepper.of" | translate }} 3
          </div>
        </div>

        @if(slotsData && slotsData.length > 0) {
        <div class="calendar-slot">
          <label for="date-calendar" style="display: none">date-calendar</label>
          <span id="date-calendar" style="display: none">date-calendar</span>
          <p-datepicker
            [(ngModel)]="selectedDate"
            [inline]="true"
            [minDate]="minDate"
            [maxDate]="maxDate"
            [disabledDates]="disabledDates"
            styleClass="costa-calendar"
            (onDateSelect)="SelectSlots($any($event))"
            [firstDayOfWeek]="1"
            [selectOtherMonths]="true"
          />
        </div>
        <div class="choose-slot">
          @if (slots) {
          <p-accordion
            [multiple]="true"
            [(value)]="accordionValue"
            styleClass="costa-slot"
          >
            <p-accordion-panel value="lunch" [disabled]="disabledLunch">
              <p-accordion-header>{{ 'lunch' | translate }}</p-accordion-header>
              <p-accordion-content>
                <div class="wrap-button-slots">
                  @for (el of slots; track el.uuid_restaurant_slot) {
                    @if(el.category === 'LUNCH') {
                    <button
                      [id]="'button-slot-' + el.slot_start"
                      class="button-slot"
                      type="button"
                      [ngClass]="{
                        selected: el.selected,
                        disabled: el.bookable === false
                      }"
                      [disabled]="!el.bookable"
                      (click)="SelectSlot(el)"
                    >
                      {{ el.slot_start }}
                    </button>
                    }
                  }
                </div>
              </p-accordion-content>
            </p-accordion-panel>

            <p-accordion-panel value="dinner" [disabled]="disabledDinner">
              <p-accordion-header>{{ 'dinner' | translate }}</p-accordion-header>
              <p-accordion-content>
                <div class="wrap-button-slots">
                  @for (el of slots; track el.uuid_restaurant_slot) {
                    @if(el.category === 'DINNER') {
                    <button
                      [id]="'button-slot-' + el.slot_start"
                      class="button-slot"
                      type="button"
                      [ngClass]="{
                        selected: el.selected,
                        disabled: el.bookable === false
                      }"
                      (click)="SelectSlot(el)"
                    >
                      {{ el.slot_start }}
                    </button>
                    }
                  }
                </div>
              </p-accordion-content>
            </p-accordion-panel>
          </p-accordion>
          } @else {
          <div class="message no-user">
            <div class="icon">
              <img src="../../../assets/images/Info.svg" alt="Info icon" />
            </div>
            <p class="text">{{ "calendar.message" | translate }}</p>
          </div>
          }
        </div>
        } @else if (loadedSlots) {
        <div class="message no-user">
          <div class="icon">
            <img src="../../../assets/images/Info.svg" alt="Info icon" />
          </div>
          <div style="white-space: pre-line">
            <p class="text">
              {{
                "calendar.no_slots"
                  | translate
                    : {
                        phone_number: phone_number
                      }
              }}
            </p>
          </div>
        </div>
        }
      </div>

      @if(slotsData && slotsData.length > 0) {
      <div class="buttons">
        <button
          class="costa-button"
          type="button"
          [disabled]="!this.selectedSlots"
          (click)="Proceed()"
        >
          {{ "proceed" | translate }}
        </button>
      </div>
      } @else if (loadedSlots) {
      <div class="buttons">
        <button class="costa-button" type="button" (click)="Close()">
          {{ "close" | translate }}
        </button>
      </div>
      }
    </div>
  </div>
</div>
